import React from 'react';
import { Box, Modal, Typography, IconButton, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Vehicle360ModalProps {
  open: boolean;
  handleClose: () => void;
  clientId: string | null;
  assetId: string | null;
}

const Vehicle360Modal: React.FC<Vehicle360ModalProps> = ({ open, handleClose, clientId, assetId }) => {
  const theme = useTheme();

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="360-view-modal">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '75%',
          height: '75%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2,
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', top: 10, right: 10, color: theme.palette.grey[700] }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" sx={{ mb: 1 }}>
          360° Interior View
        </Typography>
        {clientId && assetId && (
          <iframe
            src={`/iframe/${clientId}/${assetId}/pano`}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="360 View"
          ></iframe>
        )}
      </Box>
    </Modal>
  );
};

export default Vehicle360Modal;
